import { useAppSelector } from '@/state/hooks';
import type { AppState } from '@/state/store';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Dashboard } from '../pages/Dashboard/Dashboard';
import { PageNotFound } from '../pages/PageNotFound/PageNotFound';
import { Header } from './components/Header';
import { HelpCenter } from './components/HelpCenter';
import { MiniFooter } from './components/MiniFooter';
import { PageTracker } from './components/PageTracker';

export const PageLayout = (): JSX.Element => {
  const blotterCollapsed = useAppSelector((state: AppState) => state.ui.blotterCollapsed);

  return (
    <MainRouter>
      <div id="page" className={blotterCollapsed ? 'collapsed' : ''}>
        <Header />

        <Switch>
          <Route exact path="/" component={Dashboard} />
          <Route path="/:orderId" component={Dashboard} />
          <Route component={PageNotFound} />
        </Switch>

        <HelpCenter />
        <MiniFooter />
      </div>
    </MainRouter>
  );
};

function MainRouter({ children }: { children: JSX.Element }): JSX.Element {
  return (
    <BrowserRouter>
      <PageTracker>{children}</PageTracker>
    </BrowserRouter>
  );
}
